import type { FaireProductEntity } from "../../entity_types/product";

export const p_36rpf4umnf: FaireProductEntity = {
  token: "p_36rpf4umnf",
  type: "product",
  name: "Trace Mineral Drops",
  brandToken: "b_biy9ek6rw1",
  brandName: "Mayu Water",
  imageUrl:
    "https://cdn.faire.com/fastly/26c541b033dfa84051f9479f40a07273018a4edf45d9cabc380191d694581b86.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c8faede8048fb6c5caaaaa080519efaaa22b45361527a326596781e542b5c736.jpeg",
    "https://cdn.faire.com/fastly/737903b2443de93566613a3c39afeeb1d2c8362574f57d2e9c6b08897f7b663a.jpeg",
    "https://cdn.faire.com/fastly/cd8c024e9a81fce7e57690e2f1eec69907705b49d6154b1cb6740fffc42520ae.jpeg",
    "https://cdn.faire.com/fastly/4dd27101c54d10dcc1ca930e4264e742d01e4fb94a9a7add48edd8caea6f337d.jpeg",
    "https://cdn.faire.com/fastly/87de3b19fc0b032bf49b386ae5175b46d59170fea013350267b62caf9137a529.png",
    "https://cdn.faire.com/fastly/0263d8d7798cf01ddb76380041c9b37b36ec3730e25e1de3c7a1046f7e4b2ca0.jpeg",
    "https://cdn.faire.com/fastly/c0f8f5cf9001c9e95d66ab933ff94ce7f17f843ee2f121872347b9a5300d9272.jpeg",
    "https://cdn.faire.com/fastly/996a8cc87c7dc399dbb8c6750222277d564d2ada52ee07809b0ec11cfa696c97.png",
    "https://cdn.faire.com/fastly/2cf50d6b28def03dfa8143008c689e51bad3aae58812f07c3ab6174f14f707a6.jpeg",
    "https://cdn.faire.com/fastly/d8719c33dce3823cefde3580ef3bd5b9e62a7b8ab688b5dc3656cbbaceb790e5.jpeg",
    "https://cdn.faire.com/fastly/2b7adf82c950ed8868be5b0b139661136d48e31bff6666e6c041f817bae24327.jpeg",
    "https://cdn.faire.com/fastly/314e631366e6fa8544e11ee4a04a4cbbafc4e3ac41a0a79e546a0366b0e6694f.jpeg",
    "https://cdn.faire.com/fastly/21ac31b18171da3900d5ba22449b9cbfa0761008b047c78b37f4d8bf5f9a59aa.jpeg",
  ],
  priceDollars: 20.79,
  description:
    "Trace Minerals for Daily Wellness\n\n * Replenish Vital Nutrients: supporting bone health, nutrient absorption, and overall vitality with 75 Ionic Minerals and Micro-Elements. \n * Pure and Guilt-Free: Zero calories, sugars, or carbs, enhancing hydration naturally and fitting seamlessly into any diet. \n * Quality You Can Trust: Rigorously tested for purity, our formula provides contaminant-free nourishment for your health. \n * Higher Absorption with Liquid Form: Delivers quickly, outperforming powders and tablets. \n * Made in the USA ",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:16.732Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
